export default {
  items: [
    {
      name: 'Dashboard',
      url: '/super/dashboard',
      icon: 'icon-speedometer',
    },
    {
      name: 'Corporates',
      url: '/super/corporate',
      icon: 'icon-note',
      children: [
        {
          name: 'Create',
          url: '/super/create_corporate',
          icon: 'icon-pencil',
        },
        {
          name: 'View / Modify',
          url: '/super/view_corporates',
          icon: 'icon-list',
        },
        {
          name: 'Pending Approval',
          url: '/super/pending-approval',
          icon: 'icon-list',
        }
      ],
    },
    {
      name: 'Corporate Admins',
      url: '/super/corp_admin',
      icon: 'icon-note',
      children: [
        {
          name: 'Create',
          url: '/super/create_corp_admin',
          icon: 'icon-pencil',
        },
        {
          name: 'View / Modify',
          url: '/super/view_corp_admin',
          icon: 'icon-list',
        }
      ],
    },
    {
      name: 'System Admins',
      url: '/super/sys_admin',
      icon: 'icon-note',
      children: [
        {
          name: 'Create',
          url: '/super/sys_admin',
          icon: 'icon-pencil',
        },
        {
          name: 'View / Modify',
          url: '/super/view_sys_admin',
          icon: 'icon-list',
        }
      ],
    },
    {
      name: 'Public Users',
      url: '/super/public-users',
      icon: 'icon-note',
      children: [
        {
          name: 'View / Modify',
          url: '/super/public-users',
          icon: 'icon-list',
        }
      ],
    },
    {
      name: 'Delete Requests',
      url: '/super/delete-requests',
      icon: 'icon-note',
      children: [
        {
          name: 'Pending Requests',
          url: '/super/delete-requests/pending',
          icon: 'icon-list'
        },
        {
          name: 'Scheduled Requests',
          url: '/super/delete-requests/scheduled',
          icon: 'icon-list'
        }
      ]
    },
    {
      name: 'Reports',
      url: '/super/report',
      icon: 'icon-note',
      children: [
        {
          name: 'View SMS',
          url: '/super/view_sms',
          icon: 'icon-chart',
        },
        {
          name: 'Login Details',
          url: '/super/login-details',
          icon: 'icon-chart',
        },
        // {
        //   name: 'Users',
        //   url: '/super/quicksight-users-report',
        //   icon: 'icon-chart',
        // },
        {
          name: 'Event Insights',
          url: '/super/event-quicksight-report',
          icon: 'icon-chart',
        }
      ],
    },
  ],
};
